import React from "react";
import { Bar } from "react-chartjs-2";
import "chart.js"; // No need to manually register components in v2

import * as moment from "moment";

const projectCountByApplicationData = (data) => {
  let value = { labels: [], datasets: [{ data: [], backgroundColor: [] }] };

  value.labels = data.map((element) => moment(element.month).format("MMM YYYY"));
  value.datasets = [
    {
      data: data.map((element) => element.helioscope_count),
      label: "Helioscope",
      backgroundColor: "rgb(255, 99, 132)",
      stack: "Stack 0",
    },
    {
      data: data.map((element) => element.aurora_count),
      label: "Aurora",
      backgroundColor: "rgb(75, 192, 192)",
      stack: "Stack 0",
    },
    {
      data: data.map((element) => element.planset_count),
      label: "Planset",
      backgroundColor: "rgb(53, 162, 235)",
      stack: "Stack 0",
    },
    {
      data: data.map((element) => element.ubuilder_count),
      label: "Ubuilder",
      backgroundColor: "rgb(75, 205, 86)",
      stack: "Stack 0",
    },
  ];

  return value;
};

function productCount(rawData) {
  const labels = Object.keys(rawData);

  // Get all unique products
  const products = [...new Set(labels.flatMap((month) => Object.keys(rawData[month])))];

  // Build datasets
  const datasets = products.map((product, index) => ({
    label: product,
    stack: "Stack 1",
    data: labels.map((month) => rawData[month][product] || 0),
    backgroundColor: `hsl(${(index * 60) % 360}, 70%, 50%)`, // Unique color
  }));
  const chartData = { labels, datasets };

  return chartData;
}

const BarChart = ({ data, activeChartID }) => {
  let value = { labels: [], datasets: [{ data: [], backgroundColor: [] }] };
  const options = {
    title: {
      display: true,
      text: "Project Count based on applications - Stacked",
      fontSize: 18, // Title font size
      fontColor: "#333", // Title color
    },
    responsive: true,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  };
  if (data && (data.length > 0 || Object.keys(data).length > 0)) {
    if (activeChartID === "application_count") {
      value = projectCountByApplicationData(data);
    } else if (activeChartID === "count_by_product") {
      value = productCount(data);
      options.title.text = "Product Count";
    }
  }

  return <Bar options={options} data={value} />;
};

export default BarChart;
